import React, {Component} from "react"

import authentication from "@irati/auth"
import medicalTracking from "@irati-tracking/medical"
import {MedicalDCAUser} from "@irati/medical/types"

import Landing from "../../../components/Landing"
import StepPage from "../../../components/StepPage"
import EmailStep from "../../../components/EmailStep"
import ProfileInformationStep from "../../../components/ProfileInformationStep"

export const GET_STARTED = "step.get_started"
export const SET_EMAIL = "step.set_email"
export const SET_PROFILE_INFO = "step.set_profile_info"

interface Props {
  onCreateMedicalUser: (user: MedicalDCAUser) => void
}

interface State {
  step: string
  email: string
}

class GetStarted extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      step: GET_STARTED,
      email: authentication.user().email
    }
    medicalTracking.viewGetStarted()
  }

  handleUpdateStep = (step: string) => {
    if (step === SET_EMAIL) {
      medicalTracking.viewStep(1)
    } else if (step === SET_PROFILE_INFO) {
      medicalTracking.viewStep(2)
    }
    this.setState({step})
  }

  handleUpdateEmail = (email: string) => {
    this.setState({email})
  }

  render() {
    const {onCreateMedicalUser} = this.props
    const {step, email} = this.state
    if (step === GET_STARTED) {
      return <Landing onUpdateStep={this.handleUpdateStep} />
    }
    if (step === SET_EMAIL) {
      return (
        <StepPage currentStep={1}>
          <EmailStep email={email} onUpdateEmail={this.handleUpdateEmail} onUpdateStep={this.handleUpdateStep} />
        </StepPage>
      )
    }
    if (step === SET_PROFILE_INFO) {
      return (
        <StepPage currentStep={2}>
          <ProfileInformationStep onUpdateStep={this.handleUpdateStep} onCreateMedicalUser={onCreateMedicalUser} email={email} />
        </StepPage>
      )
    }
    return <div>Invalid Step</div>
  }
}

export default GetStarted
